import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import { SaveRouteAsSelectionSetIcon } from '@icons/save-route-as-selection-set/SaveRouteAsSelectionSetIcon';
import { themeColors } from '@styles/theme';
import { useTheme } from '@context/themeContext';
import { GroupSelectionProvider } from '@context/groupSelectionContext';
import { PublicTransitLayerEntityName } from '@api/entities/replancity_PublicTransitLine';
import { useSaveRouteAsSelectionSet } from '../model/useSaveRouteAsSelectionSet';
import SaveRouteAsSelectionSetModal from './SaveRouteAsSelectionSetModal';
import { IconButton } from '@components/buttons/IconButton/IconButton';

type SaveRouteAsSelectionSetProps = {
    ids: string[];
};

const SaveRouteAsSelectionSetInner = memo(({ ids }: SaveRouteAsSelectionSetProps) => {
    const { theme } = useTheme();
    const { t } = useTranslation();
    const {
        isModalOpen,
        openModal,
        setModalOpen,
        setName,
        onNameChange,
        onSubmit,
        canSave,
        saving,
    } = useSaveRouteAsSelectionSet({ ids });

    return (
        <div className="save-route-as-selection-set">
            <Tooltip title={t('road-network.group-selection-save-set-submit-btn')}>
                <IconButton
                    icon={() => (
                        <SaveRouteAsSelectionSetIcon
                            color={theme === 'light' ? themeColors.bluePurple : themeColors.white}
                        />
                    )}
                    width={24}
                    height={24}
                    borderless
                    onClick={openModal}
                    disabled={saving}
                />
            </Tooltip>
            {isModalOpen ? (
                <SaveRouteAsSelectionSetModal
                    setModalShow={setModalOpen}
                    name={setName}
                    onNameChange={onNameChange}
                    onSubmit={onSubmit}
                    saving={saving}
                    canSave={canSave}
                />
            ) : null}
        </div>
    );
});

const SaveRouteAsSelectionSet = memo(({ ids }: SaveRouteAsSelectionSetProps) => {
    return (
        <GroupSelectionProvider
            entityName={PublicTransitLayerEntityName.ROUTES}
            sourceEntityName={PublicTransitLayerEntityName.ROUTES}
        >
            <SaveRouteAsSelectionSetInner ids={ids} />
        </GroupSelectionProvider>
    );
});

export default SaveRouteAsSelectionSet;
